import { subscribeToPageLoadEvent, unsubscribeFromPageLoadEvent } from '@ms/yammer-page-route-telemetry';
import { flushTelemetryEvents } from '@ms/yammer-telemetry';
import {
  notifyAppExpectedFailure,
  notifyAppInitializationFailure,
  notifyAppInitializationSuccess,
} from '@ms/yammer-web-support/dist/metaOsHub';
import { teamsContextStore } from 'state/teamsContext';

let isSubscribed = false;
let hasReportedLoadEvent = false;

const notifyTeamsOfPageLoad = () => {
  if (!hasReportedLoadEvent) {
    hasReportedLoadEvent = true;
    notifyAppInitializationSuccess();
    setAppStateToNotCached();
  }
};

const notifyTeamsOfExpectedPageFailure = () => {
  if (!hasReportedLoadEvent) {
    hasReportedLoadEvent = true;
    notifyAppExpectedFailure('Page hero content failed to load, with recovery UI');
    setAppStateToNotCached();
  }
};

const notifyTeamsOfPageFailure = () => {
  if (!hasReportedLoadEvent) {
    hasReportedLoadEvent = true;
    notifyAppInitializationFailure('Page hero content failed to load');
  }
};

// Wrapper to handle async timeout handler
const notifyTeamsOfPageLoadTimeoutWrapper = () => {
  void notifyTeamsOfPageLoadTimeout();
};
const notifyTeamsOfPageLoadTimeout = async () => {
  if (!hasReportedLoadEvent) {
    hasReportedLoadEvent = true;
    // Flush all queued telemetry events before Teams hijacks the iframe
    // The timeout performance event is now awaited in the page load telemetry module,
    // ensuring it's fully enqueued before the TimedOut event is emitted
    await flushTelemetryEvents();
    notifyAppInitializationFailure('Page hero content failed to load within 30 seconds');
  }
};

const setAppStateToNotCached = () => {
  teamsContextStore.getState().setIsCached(false);
};

export const subscribeTeamsToNextPageLifecycleEvent = () => {
  hasReportedLoadEvent = false;

  if (isSubscribed) {
    return;
  }

  isSubscribed = true;

  subscribeToPageLoadEvent('Loaded', notifyTeamsOfPageLoad);
  subscribeToPageLoadEvent('FailedRecoverable', notifyTeamsOfExpectedPageFailure);
  subscribeToPageLoadEvent('Failed', notifyTeamsOfPageFailure);
  subscribeToPageLoadEvent('TimedOut', notifyTeamsOfPageLoadTimeoutWrapper);
};

export const unsubscribeTeamsFromPageLifecycleEvents = () => {
  isSubscribed = false;

  unsubscribeFromPageLoadEvent('Loaded', notifyTeamsOfPageLoad);
  unsubscribeFromPageLoadEvent('FailedRecoverable', notifyTeamsOfExpectedPageFailure);
  unsubscribeFromPageLoadEvent('Failed', notifyTeamsOfPageFailure);
  unsubscribeFromPageLoadEvent('TimedOut', notifyTeamsOfPageLoadTimeoutWrapper);
};
